export const DEADLINE_OPTIONS: Array<{ label: string; value: string }> = [
  { label: '2 Hours', value: '2 Hours' },
  { label: '4 Hours', value: '4 Hours' },
  { label: '6 Hours', value: '6 Hours' },
  { label: '8 Hours', value: '8 Hours' },
  { label: '10 Hours', value: '10 Hours' },
  { label: '12 Hours', value: '12 Hours' },
  { label: '14 Hours', value: '14 Hours' },
  { label: '16 Hours', value: '16 Hours' },
  { label: '18 Hours', value: '18 Hours' },
  { label: '20 Hours', value: '20 Hours' },
  { label: '22 Hours', value: '22 Hours' },
  { label: '24 Hours', value: '24 Hours' },
  { label: '36 Hours', value: '36 Hours' },
  { label: '48 Hours', value: '48 Hours' },
  { label: '60 Hours', value: '60 Hours' },
  { label: '72 Hours', value: '72 Hours' },
];
